import { render, staticRenderFns } from "./module-extension.vue?vue&type=template&id=ed5f3806&"
import script from "./module-extension.vue?vue&type=script&lang=js&"
export * from "./module-extension.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports